<template>
  <b-card>
    <h2 class="text-primary">{{ $t('survey.info.info') }}</h2>

    <b-form class="mt-2">
      <b-row>
        <b-col sm="12">
          <b-badge variant="primary">
            <span style="font-size: medium;">{{ optionsLocal.surveyType }}</span>
          </b-badge>
          <b-form-group :label="$t('survey.title')" class="mt-3" label-for="survey-title"
            :state="optionsLocal.title ? true : false">
            <b-form-input v-model="optionsLocal.title" :placeholder="$t('survey.placeholder.title')" name="title"
              required :state="optionsLocal.title ? true : false" />
            <template v-slot:invalid-feedback>
              {{ $t('survey.required.title') }}
            </template>
          </b-form-group>

        </b-col>
        <b-col sm="12">
          <b-form-group :label="$t('survey.code')" label-for="account-name"
            :state="optionsLocal.surveyCode ? true : false">
            <b-form-input v-model="optionsLocal.surveyCode" name="surveyCode"
              :placeholder="$t('survey.placeholder.code')" required :state="optionsLocal.surveyCode ? true : false" />
            <template v-slot:invalid-feedback>
              {{ $t('survey.required.code') }}
            </template>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mt-2 mr-1"
            @click.prevent="sendInformation">
            {{ $t("Save Changes") }}
          </b-button>

          <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="reset" class="mt-1"
            :disabled="isLoading ? true : false" variant="outline-secondary" @click.prevent="resetFile">
            {{ $t('Reset') }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BBadge,
  BFormFile,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BAlert,
  BCard,
  BCardText,
  BMedia,
  BMediaAside,
  BMediaBody,
  BLink,
  BImg,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
import { ref } from "@vue/composition-api";

import CourseTypePicker from '../components/SurveyTypePicker.vue';



export default {
  components: {
    BBadge,
    BButton,
    BForm,
    BImg,
    BFormFile,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BAlert,
    BCard,
    BCardText,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
    CourseTypePicker

  },
  directives: {
    Ripple,
  },
  props: {
    generalData: {
      type: Object,
      default: () => { },
    },
    courseId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      place: null, // optional,
      localOptions: {},
      isLoading: false,
      file: null,
      isUpdated: false,
      optionsLocal: JSON.parse(JSON.stringify(this.generalData.data)),
      profileFile: null,
      location: {
        lat: 41.0082376,
        lng: 28.97835889999999
      },
      options: { // is not required
        map: {/** other map options **/ },
        marker: { /** marker options **/ },
        autocomplete: { /** autocomplete options **/ }
      },
    };
  },
  methods: {
    setSecuredImage(fileName) {
      axios
        .get("upload/admin/file/" + fileName + "?type=survey")
        .then((response) => {
          this.securedImage = response.data.url;
        })
        .catch((error) => {
          
          console.error(error);
        });
    },
    resetFile() {
      this.optionsLocal.surveyCode = null;
      this.optionsLocal.title = null;
    },
    clearFiles() {
      this.$refs["file-input"].reset();
    },

    fileSelected(payload) {
      const formData = new FormData();
      formData.append("file", payload);
      formData.append("courseId", this.courseId);
      formData.append("acc", 3);
      formData.append("platform", "webadmin");
      this.isLoading = true;

      axios
        .post("/upload/admin", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          //console.log(response);
          this.optionsLocal.featuredImage = response.data.url;
          this.isUpdated = true;
          this.isLoading = false;
          this.$bvToast.toast(`${response.data.message}`, {
            title: "Success",
            autoHideDelay: 5000,
            appendToast: true,
            variant: "success",
            solid: true,
          });
        })
        .catch((error) => {
          //console.log(error);
          this.isLoading = false;
          this.$bvToast.toast(`${error.response.data.message}`, {
            title: "Error",
            autoHideDelay: 5000,
            appendToast: true,
            variant: "danger",
            solid: true,
          });
        });
    },

    authorChanged(payload) {
      //console.log(payload);
      this.optionsLocal.ClientInstructors = Array.isArray(payload)
        ? payload
        : [payload];

      //console.log(this.optionsLocal);
    },

    courseModeUpdated(payload) {
      //console.log("Catefy result in info ");
      //console.log(payload);
      this.optionsLocal.coursemode = payload.name;
    },

    courseCategoryUpdated(payload) {
      //console.log("Catefy result in info ");
      //console.log(payload);
      this.optionsLocal.CourseCategories = Array.isArray(payload)
        ? payload
        : [payload];
    },

    sendInformation() {
      // Validation: title and surveyCode must not be empty
      if (!this.optionsLocal.title || !this.optionsLocal.surveyCode) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: this.$t("survey.required.fill"),
            icon: "AlertOctagonIcon",
            variant: "danger",
          },
        });
        return;
      }
      this.isLoading = true;
      axios({
        method: "put",
        url: `/survey/admin/surveydetail/${this.courseId}`,
        data: {
          info: "general",
          file: null,
          content: this.optionsLocal,
        },
      })
        .then((r) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Success`,
              icon: "CheckCircleIcon",
              variant: "success",
            },
          });
          this.isLoading = false;
          this.isUpdated = false;
        })
        .catch((r) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Error`,
              icon: "AlertOctagonIcon",
              variant: "warning",
            },
          });
          this.isLoading = false;
        });
      return;
    },
    resetForm() {
      this.optionsLocal = JSON.parse(JSON.stringify(this.generalData.data));
    },

    uploadFile(paylod) {
      this.optionsLocal = JSON.parse(JSON.stringify(this.generalData.data));
    },
  },
  mounted() {

  },
  setup() {
    const refInputEl = ref(null);
    const previewEl = ref(null);

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, previewEl);

    return {
      refInputEl,
      previewEl,
      inputImageRenderer,
    };
  },
};
</script>
